'use client'

import { FC } from 'react'

const SPDetailPanelStyles: FC = () => {
  return (
    <style>{`
      .sp-detail-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 10000;
        display: flex;
        flex-direction: column;
      }

      .sp-detail-backdrop {
        flex: 0 0 auto;
        height: 15%;
      }

      .sp-detail-panel {
        flex: 1;
        background: white;
        border-radius: 20px 20px 0 0;
        display: flex;
        flex-direction: column;
        animation: slideUp 300ms ease-out;
        overflow: hidden;
      }

      .sp-detail-panel.closing {
        animation: slideDown 300ms ease-out forwards;
      }

      @keyframes slideUp {
        from { transform: translateY(100%); }
        to { transform: translateY(0); }
      }

      @keyframes slideDown {
        from { transform: translateY(0); }
        to { transform: translateY(100%); }
      }

      .sp-detail-header {
        padding: 16px;
        display: flex;
        justify-content: flex-end;
        flex-shrink: 0;
      }

      .sp-detail-close {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        cursor: pointer;
        color: #666;
      }

      .sp-detail-content {
        flex: 1;
        overflow-y: auto;
        padding: 0 20px;
padding-bottom: 20px;
text-align: justify;
      }

      .sp-detail-title {
        font-size: 21px;
        font-weight: bold;
        color: var(--video-brand-color, var(--video-accent-color, #1d48af));
        line-height: 1.5;
        margin-bottom: 14px;
      }

      .sp-detail-section {
        margin-bottom: 16px;
      }

      .sp-detail-section-label {
        font-size: 12px;
        font-weight: bold;
        color: #333;
        margin-bottom: 4px;
        padding-left: 12px;
        border-left: 3px solid var(--video-brand-color, var(--video-accent-color));
      }

      .sp-detail-section-value {
        font-size: 18px;
        color: #666;
      }

      .sp-detail-heading {
        font-size: 15px;
        font-weight: bold;
        color: #333;
        margin-bottom: 12px;
        padding-left: 12px;
        border-left: 3px solid var(--video-brand-color, var(--video-accent-color));
      }

      .sp-detail-text {
        font-size: 14px;
        line-height: 1.8;
        color: #444;
        white-space: pre-wrap;
      }

      .sp-detail-cta-container {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 10px 12px;
        z-index: 2;
      }

      .info-bottom-fade {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 120px;
        background: linear-gradient(transparent, white);
        pointer-events: none;
        z-index: 1;
      }

      .sp-detail-cta-button {
        width: 100%;
        padding: 12px 24px;
        background: var(--video-brand-color, var(--video-accent-color, #1d48af));
        color: white;
        font-size: 16px;
        font-weight: bold;
        border: none;
        border-radius: 10px;
        cursor: pointer;
        box-shadow: 0 4px 12px color-mix(in srgb, var(--video-brand-color, var(--video-accent-color)) 30%, transparent);
      }

      .sp-detail-cta-button:hover {
        background: var(--video-brand-hover-color, var(--video-accent-hover-color, #17398c));
      }
    `}</style>
  )
}

export default SPDetailPanelStyles
